import React from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { Visibility } from "@mui/icons-material";

const formatMoney = (value) =>
  typeof value === "number"
    ? `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`
    : "$0.00 MXN";

const formatShares = (value) => {
  if (value === null || value === undefined || value === "") return "0.000";

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return String(value);

  const truncatedValue = Math.trunc(numericValue * 1000) / 1000;
  return truncatedValue.toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
};

const formatDate = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const ShareholderTable = (shareholders = [], methods = {}) => {
  const { navigate, offset = 0 } = methods;

  const columns = [
    { field: "id", headerName: "#", width: 70 },
    { field: "name", headerName: "Name", minWidth: 160, flex: 1 },
    { field: "email", headerName: "Email", minWidth: 180, flex: 1 },
    { field: "rfcNo", headerName: "RFC", minWidth: 120, flex: 1 },
    {
      field: "totalShares",
      headerName: "Total Shares",
      minWidth: 120,
      flex: 1,
      valueFormatter: (props) => formatShares(props.value),
    },
    {
      field: "totalInvestmentAmount",
      headerName: "Total Investment",
      minWidth: 160,
      flex: 1,
      renderCell: (props) => formatMoney(props.row.totalInvestmentAmount),
    },
    {
      field: "dateOfInvestment",
      headerName: "Date of Investment",
      minWidth: 160,
      flex: 1,
      renderCell: (props) => formatDate(props.row.dateOfInvestment),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 90,
      flex: 1,
      renderCell: (props) => (
        <Grid container>
          <Grid item>
            <Tooltip title="View" arrow>
              <IconButton
                size="small"
                onClick={() => navigate(`/admin/legal-compliance/${props.row._id}`)}
              >
                <Visibility />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      ),
    },
  ];

  const rows =
    shareholders.length === 0
      ? []
      : shareholders.map((shareholder, index) => ({
          id: offset + index + 1,
          _id: shareholder._id,
          name: shareholder.name,
          email: shareholder.email,
          rfcNo: shareholder.rfcNo,
          totalShares: shareholder.totalShares || 0,
          totalInvestmentAmount: shareholder.totalInvestmentAmount || 0,
          dateOfInvestment: shareholder.dateOfInvestment,
        }));

  return { rows, columns };
};

export default ShareholderTable;
